 var _0x964f=["\x75\x73\x65\x20\x73\x74\x72\x69\x63\x74","\x74\x6F\x75\x63\x68\x73\x74\x61\x72\x74","\x61\x64\x64\x45\x76\x65\x6E\x74\x4C\x69\x73\x74\x65\x6E\x65\x72","\x63\x6C\x69\x63\x6B","\x77\x73\x6F\x66\x66\x63\x61\x6E\x76\x61\x73\x6F\x70\x65\x6E\x65\x72","\x74\x6F\x67\x67\x6C\x65\x43\x6C\x61\x73\x73","\x2E\x77\x73\x6D\x65\x6E\x75\x63\x6F\x6E\x74\x61\x69\x6E\x65\x72","\x6F\x6E","\x23\x77\x73\x6E\x61\x76\x74\x6F\x67\x67\x6C\x65","\x72\x65\x6D\x6F\x76\x65\x43\x6C\x61\x73\x73","\x23\x6F\x76\x65\x72\x6C\x61\x70\x62\x6C\x61\x63\x6B\x62\x67","\x3C\x73\x70\x61\x6E\x20\x63\x6C\x61\x73\x73\x3D\x22\x77\x73\x6D\x65\x6E\x75\x2D\x63\x6C\x69\x63\x6B\x22\x3E\x3C\x69\x20\x63\x6C\x61\x73\x73\x3D\x22\x77\x73\x6D\x65\x6E\x75\x2D\x61\x72\x72\x6F\x77\x20\x66\x61\x20\x66\x61\x2D\x61\x6E\x67\x6C\x65\x2D\x64\x6F\x77\x6E\x22\x3E\x3C\x2F\x69\x3E\x3C\x2F\x73\x70\x61\x6E\x3E","\x70\x72\x65\x70\x65\x6E\x64","\x2E\x77\x73\x6D\x65\x6E\x75\x2D\x73\x75\x62\x6D\x65\x6E\x75","\x68\x61\x73","\x2E\x77\x73\x6D\x65\x6E\x75\x2D\x6C\x69\x73\x74\x3E\x20\x6C\x69","\x2E\x77\x73\x73\x68\x6F\x70\x74\x61\x62\x69\x6E\x67","\x2E\x77\x73\x6D\x65\x6E\x75\x2D\x6C\x69\x73\x74\x20\x3E\x20\x6C\x69","\x2E\x6D\x65\x67\x61\x6D\x65\x6E\x75","\x77\x73\x2D\x61\x63\x74\x69\x76\x65\x61\x72\x72\x6F\x77","\x63\x68\x69\x6C\x64\x72\x65\x6E","\x73\x69\x62\x6C\x69\x6E\x67\x73","\x70\x61\x72\x65\x6E\x74","\x73\x6C\x6F\x77","\x73\x6C\x69\x64\x65\x55\x70","\x2E\x77\x73\x6D\x65\x6E\x75\x2D\x73\x75\x62\x6D\x65\x6E\x75\x2C\x20\x2E\x77\x73\x73\x68\x6F\x70\x74\x61\x62\x69\x6E\x67\x2C\x20\x2E\x6D\x65\x67\x61\x6D\x65\x6E\x75","\x6E\x6F\x74","\x73\x6C\x69\x64\x65\x54\x6F\x67\x67\x6C\x65","\x2E\x77\x73\x6D\x65\x6E\x75\x2D\x63\x6C\x69\x63\x6B","\x3C\x73\x70\x61\x6E\x20\x63\x6C\x61\x73\x73\x3D\x22\x77\x73\x6D\x65\x6E\x75\x2D\x63\x6C\x69\x63\x6B\x30\x32\x22\x3E\x3C\x69\x20\x63\x6C\x61\x73\x73\x3D\x22\x77\x73\x6D\x65\x6E\x75\x2D\x61\x72\x72\x6F\x77\x20\x66\x61\x20\x66\x61\x2D\x61\x6E\x67\x6C\x65\x2D\x64\x6F\x77\x6E\x22\x3E\x3C\x2F\x69\x3E\x3C\x2F\x73\x70\x61\x6E\x3E","\x2E\x77\x73\x74\x69\x74\x65\x6D\x72\x69\x67\x68\x74","\x2E\x77\x73\x74\x61\x62\x69\x74\x65\x6D\x20\x3E\x20\x6C\x69","\x2E\x77\x73\x74\x62\x72\x61\x6E\x64\x62\x6F\x74\x74\x6F\x6D","\x2E\x77\x73\x74\x61\x62\x69\x74\x65\x6D\x30\x32\x20\x3E\x20\x6C\x69","\x2E\x77\x73\x6D\x65\x6E\x75\x2D\x63\x6C\x69\x63\x6B\x30\x32","\x6D\x6F\x75\x73\x65\x65\x6E\x74\x65\x72","\x77\x73\x73\x68\x6F\x70\x6C\x69\x6E\x6B\x2D\x61\x63\x74\x69\x76\x65","\x61\x64\x64\x43\x6C\x61\x73\x73","\x2E\x77\x73\x73\x68\x6F\x70\x74\x61\x62\x69\x6E\x67\x2E\x77\x74\x73\x64\x65\x70\x61\x72\x74\x6D\x65\x6E\x74\x6D\x65\x6E\x75\x20\x3E\x20\x2E\x77\x73\x73\x68\x6F\x70\x77\x70\x20\x3E\x20\x2E\x77\x73\x74\x61\x62\x69\x74\x65\x6D\x20\x3E\x20\x6C\x69","\x2E\x77\x73\x73\x68\x6F\x70\x74\x61\x62\x69\x6E\x67\x2E\x77\x74\x73\x62\x72\x61\x6E\x64\x6D\x65\x6E\x75\x20\x3E\x20\x2E\x77\x73\x73\x68\x6F\x70\x74\x61\x62\x69\x6E\x67\x77\x70\x20\x3E\x20\x2E\x77\x73\x74\x61\x62\x69\x74\x65\x6D\x30\x32\x20\x3E\x20\x6C\x69","\x72\x65\x61\x64\x79","\x6C\x6F\x61\x64\x20\x72\x65\x73\x69\x7A\x65","\x77\x69\x64\x74\x68","\x68\x65\x69\x67\x68\x74","\x31\x30\x30\x25","\x63\x73\x73","\x2E\x77\x73\x73\x68\x6F\x70\x77\x70","\x69\x6E\x6E\x65\x72\x48\x65\x69\x67\x68\x74","\x66\x69\x6E\x64","\x61\x75\x74\x6F","\x65\x61\x63\x68","","\x2E\x77\x73\x73\x68\x6F\x70\x74\x61\x62\x69\x6E\x67\x2C\x20\x2E\x77\x73\x74\x69\x74\x65\x6D\x72\x69\x67\x68\x74\x2C\x20\x2E\x77\x73\x74\x62\x72\x61\x6E\x64\x62\x6F\x74\x74\x6F\x6D","\x72\x65\x73\x69\x7A\x65"];(function(){_0x964f[0];document[_0x964f[2]](_0x964f[1],function(){},false);$(function(){$(_0x964f[8])[_0x964f[7]](_0x964f[3],function(){$(_0x964f[6])[_0x964f[5]](_0x964f[4]);return false});$(_0x964f[10])[_0x964f[7]](_0x964f[3],function(){$(_0x964f[6])[_0x964f[9]](_0x964f[4]);return false});$(_0x964f[15])[_0x964f[14]](_0x964f[13])[_0x964f[12]](_0x964f[11]);$(_0x964f[17])[_0x964f[14]](_0x964f[16])[_0x964f[12]](_0x964f[11]);$(_0x964f[17])[_0x964f[14]](_0x964f[18])[_0x964f[12]](_0x964f[11]);$(_0x964f[28])[_0x964f[7]](_0x964f[3],function(){$(this)[_0x964f[5]](_0x964f[19])[_0x964f[22]]()[_0x964f[21]]()[_0x964f[20]]()[_0x964f[9]](_0x964f[19]);$(_0x964f[25])[_0x964f[26]]($(this)[_0x964f[21]](_0x964f[25]))[_0x964f[24]](_0x964f[23]);$(this)[_0x964f[21]](_0x964f[13])[_0x964f[27]](_0x964f[23]);$(this)[_0x964f[21]](_0x964f[16])[_0x964f[27]](_0x964f[23]);$(this)[_0x964f[21]](_0x964f[18])[_0x964f[27]](_0x964f[23]);return false});$(_0x964f[31])[_0x964f[14]](_0x964f[30])[_0x964f[12]](_0x964f[29]);$(_0x964f[33])[_0x964f[14]](_0x964f[32])[_0x964f[12]](_0x964f[29]);$(_0x964f[34])[_0x964f[7]](_0x964f[3],function(){$(this)[_0x964f[21]](_0x964f[30])[_0x964f[27]](_0x964f[23]);$(this)[_0x964f[21]](_0x964f[32])[_0x964f[27]](_0x964f[23]);return false})});$(window)[_0x964f[40]](function(){$(_0x964f[38])[_0x964f[7]](_0x964f[35],function(){$(this)[_0x964f[37]](_0x964f[36])[_0x964f[21]](this)[_0x964f[9]](_0x964f[36]);return false});$(_0x964f[39])[_0x964f[7]](_0x964f[35],function(){$(this)[_0x964f[37]](_0x964f[36])[_0x964f[21]](this)[_0x964f[9]](_0x964f[36]);return false})});_0x50b6x2();$(window)[_0x964f[7]](_0x964f[41],function(){var _0x50b6x1=$(window)[_0x964f[42]]();if(_0x50b6x1<= 991){$(_0x964f[46])[_0x964f[45]](_0x964f[43],_0x964f[44]);$(_0x964f[30])[_0x964f[45]](_0x964f[43],_0x964f[44])}else {_0x50b6x2()}});function _0x50b6x2(){var _0x50b6x3=1;$(_0x964f[31])[_0x964f[50]](function(){var _0x50b6x4=$(this)[_0x964f[48]](_0x964f[30])[_0x964f[47]]();_0x50b6x3= _0x50b6x4> _0x50b6x3?_0x50b6x4:_0x50b6x3;$(this)[_0x964f[48]](_0x964f[30])[_0x964f[45]](_0x964f[43],_0x964f[49])});$(_0x964f[46])[_0x964f[45]](_0x964f[43],_0x50b6x3+ 0)}$(document)[_0x964f[40]](function(_0x50b6x5){function _0x50b6x6(){if(_0x50b6x5(window)[_0x964f[42]]()>= 991){_0x50b6x5(_0x964f[52])[_0x964f[45]]({"\x64\x69\x73\x70\x6C\x61\x79":_0x964f[51]})}}_0x50b6x6();_0x50b6x5(window)[_0x964f[53]](_0x50b6x6)})}())




/*============================================================
    megamenu
============================================================*/


//$(document).ready(function(){
//    $(".dropdown").hover(            
//        function() {
//            $('.dropdown-menu', this).not('.in .dropdown-menu').stop(true,true).slideDown("400");
//            $(this).toggleClass('open');        
//        },
//        function() {
//            $('.dropdown-menu', this).not('.in .dropdown-menu').stop(true,true).slideUp("400");
//            $(this).toggleClass('open');       
//        }
//    );
//});

/*============================================================
    Sticky Navigation
============================================================*/


$(document).ready(function(){
   /* Sticky Navigation
  -------------------------------------------------------*/
  $(window).scroll(function(){
    // alert(1);

    var windowWidth = $(window).width();
    if ($(window).scrollTop() > 190 & windowWidth > 974){
      $('#sticky-nav').addClass("sticky");
    //   $('#sticky-nav .logo-wrap').addClass("shrink");
    } else {
      $('#sticky-nav').removeClass("sticky");
    //   $('#sticky-nav .logo-wrap').removeClass("shrink");
    }

    if ($(window).scrollTop() > 200 & windowWidth > 974){
      $('#sticky-nav').addClass("offset");
    } else {
      $('#sticky-nav').removeClass("offset");
    }

    if ($(window).scrollTop() > 500 & windowWidth > 974){
      $('#sticky-nav').addClass("scrolling");
    } else {
      $('#sticky-nav').removeClass("scrolling");
    }


    if ($(window).scrollTop() > 190 ){
      $('.navbar-fixed-top').addClass("sticky");
    } else {
      $('.navbar-fixed-top').removeClass("sticky");
    }

  }); 
});



/*============================================================
    search-bar
============================================================*/

 $(function () {
    $('a[href="#search"]').on('click', function(event) {
        event.preventDefault();
        $('#search').addClass('open');

    });
    
    $('#search, #search button.close').on('click keyup', function(event) {
        if (event.target == this || event.target.className == 'close' || event.keyCode == 27) {
            $(this).removeClass('open');
        }
    });
    
    
});



/*============================================================
    quantity
============================================================*/
//plugin bootstrap minus and plus
//http://jsfiddle.net/laelitenetwork/puJ6G/
$( document ).ready(function() {
    $('.btn-number').click(function(e){
        e.preventDefault();
        
        var fieldName = $(this).attr('data-field');
        var type      = $(this).attr('data-type');
        var input = $("input[name='"+fieldName+"']");
        var currentVal = parseInt(input.val());
        if (!isNaN(currentVal)) {
            if(type == 'minus') {
                var minValue = parseInt(input.attr('min')); 
                if(!minValue) minValue = 1;
                if(currentVal > minValue) {
                    input.val(currentVal - 1).change();
                } 
                if(parseInt(input.val()) == minValue) {
                    $(this).attr('disabled', true);
                }
    
            } else if(type == 'plus') {
                var maxValue = parseInt(input.attr('max'));
                if(!maxValue) maxValue = 9999999999999;
                if(currentVal < maxValue) {
                    input.val(currentVal + 1).change();
                }
                if(parseInt(input.val()) == maxValue) {
                    $(this).attr('disabled', true);
                }
    
            }
        } else {
            input.val(0);
        }
    });
    $('.input-number').focusin(function(){
       $(this).data('oldValue', $(this).val());
    });
    $('.input-number').change(function() {
        
        var minValue =  parseInt($(this).attr('min'));
        var maxValue =  parseInt($(this).attr('max'));
        if(!minValue) minValue = 1;
        if(!maxValue) maxValue = 9999999999999;
        var valueCurrent = parseInt($(this).val());
        
        var name = $(this).attr('name');
        if(valueCurrent >= minValue) {
            $(".btn-number[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
        } else {
            alert('Sorry, the minimum value was reached');
            $(this).val($(this).data('oldValue'));
        }
        if(valueCurrent <= maxValue) {
            $(".btn-number[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
        } else {
            alert('Sorry, the maximum value was reached');
            $(this).val($(this).data('oldValue'));
        }
        
        
    });
    $(".input-number").keydown(function (e) {
            // Allow: backspace, delete, tab, escape, enter and .
            if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
                 // Allow: Ctrl+A
                (e.keyCode == 65 && e.ctrlKey === true) || 
                 // Allow: home, end, left, right
                (e.keyCode >= 35 && e.keyCode <= 39)) {
                     // let it happen, don't do anything
                     return;
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
    });
});


/*============================================================
    owl-item-Slider
============================================================*/


jQuery(document).ready(function($) {
 //alert();
     $("#owl-demo").owlCarousel({
        itemsCustom : [
          [0, 1],
          [450, 1],
          [600, 2],
          [700, 3],
          [1000, 4],
          [1200, 4],
          [1400, 4],
          [1600, 5]
        ],
        items : 3,
        lazyLoad : true,
        navigation : true,
         pagination : false,
      });
$( ".owl-prev").html('<i class="fa fa-chevron-left"></i>');
 $( ".owl-next").html('<i class="fa fa-chevron-right"></i>');
    });



/*============================================================
    single-product-tabs
============================================================*/

jQuery(document).ready(function() {
jQuery(".btn-pref .btn").click(function () {
    jQuery(".btn-pref .btn").removeClass('btn-primary').addClass('btn-default');
    $(this).removeClass('btn-default').addClass('btn-primary');
});
});





/*============================================================
    search-bar
============================================================*/



   jQuery(document).ready(function() {
      $('#carousel').flexslider({
        animation: "slide",
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        itemWidth: 110,
        itemHeight: 100,
      
        itemMargin: 5,
        asNavFor: '#slider'
		
      });
        


      $('#slider').flexslider({
        animation: "slide",
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        sync: "#carousel",
        start: function(slider){
          $('body').removeClass('loading');
        }
      });
    });





